<template>
  <div class="flex-box vertical create-schedule">
    <div class="content-title">
      <div class="content-title-text">活动日程</div>
    </div>
    <div class="gap top"></div>
    <a-spin v-if="loading" style="margin-top: 10px"/>
    <div class="flex-grow scroll-area sch-date-list">
      <a-card
        class="sch-date-item"
        v-for="(s, i) in list"
        :key="s.date">
        <div class="flex-box align-center" slot="title">
          <div class="sch-date-title">{{`日期：${s.date}`}}</div>
          <div class="sch-date-progress" v-if="!create && s.list && s.list.length > 0">
            <a-progress :percent="s.per"/>
          </div>
        </div>
        <a-button type="primary" @click="addSch(i)" slot="extra" v-if="editable">
          <a-icon type="plus-circle" />添加日程
        </a-button>
        <a-table
          :columns="columns"
          :data-source="getSchShowList(s.list, i)"
          :pagination="false"
          bordered
          v-if="s.list && s.list.length > 0"></a-table>
      </a-card>
    </div>
    <a-modal
      :title="`${si === null ? '添加' : '编辑'}${date}日程`"
      centered
      ok-text="完成"
      :maskClosable="false"
      :closable="false"
      :width="1000"
      @ok="confirmModal"
      v-model="visible">
      <sch-form
        ref="modalForm"
        :label-col="{span: 3}"
        :wrapper-col="{span: 12}"
        :activity="activity"
        :schedule="schedule"></sch-form>
    </a-modal>
  </div>
</template>

<script>
    import {clone, getDate, omit, isArray} from "../../../common/js/tool";
    import SchForm from "./SchForm";
    import {getActivityTaskId} from "../../../common/activity/schedule";
    import {getTaskStatusText} from "../../../common/activity/task";
    import {generateDaySchList, getActivityDayList, getProgressPercent} from "../../../common/activity/activity";
    import mixins from "../mixins";
    const getCustomRender = (fn) => {
        return (text, record, index) => {
            let children = text;
            if(typeof fn === "function") {
                children = fn(text, record, index);
            } else if(typeof fn === "string") {
                children = record.schedule[fn];
            }
            return {
                children,
                attrs: {
                    rowSpan: record.rowSpan
                }
            }
        }
    }
    const TaskStatusIconType = ['clock-circle', 'check-circle', 'exclamation-circle']

    export default {
        name: "CreateSchedule",
        components: {
            SchForm
        },
        mixins: [mixins],
        props: {
            create: Boolean,
            value: Array,
        },
        data() {
            return {
                date: "",
                di: null, // 操作的日期下标
                si: null, // 操作的日程下标
                list: [],
                visible: false,
                schedule: {},
                loading: false
            }
        },
        computed: {
            activity() {
                return this.$store.getters.activity;
            },
            columns() {
                const create = this.create;
                const res = [
                    { title: '时间', dataIndex: 'showTime', width: 80, customRender: getCustomRender('showTime') },
                    { title: '活动安排', dataIndex: 'activity_arrange', width: 120, customRender: getCustomRender('activity_arrange') },
                    { title: '活动地点', dataIndex: 'location', width: 120, customRender: getCustomRender('location') },
                    {
                        title: '负责人',
                        dataIndex: 'leader',
                        width: 90,
                        customRender: getCustomRender((text, record) => record.schedule.leader && record.schedule.leader.length > 0 ? record.schedule.leader[0].name : "--")
                    },
                    {
                        title: '任务ID',
                        dataIndex: 'task_sort',
                        width: 90,
                        customRender: (text, record) => getActivityTaskId(record.schedule.activity_id, text)
                    },
                    {
                        title: '任务',
                        dataIndex: 'name',
                        customRender: (text, record) => {
                            return <div class="flex-box align-center">
                                <a-tooltip>
                                    <template slot="title">
                                        <span>{ record.temp_id ? '固定任务' : '自定义任务'}</span>
                                    </template>
                                    {
                                        record.temp_id ?
                                            <div class="sch-task-type sch-static-task">固</div> :
                                            <div class="sch-task-type sch-custom-task">自</div>
                                    }
                                </a-tooltip>
                                {
                                    !create ?
                                        <a-tooltip>
                                            <template slot="title">
                                                <span>{record.statusText}</span>
                                            </template>
                                            <a-icon type={TaskStatusIconType[record.status]} class={`sch-task-status task-status-${record.status}`} theme="filled"/>
                                        </a-tooltip> : null
                                }

                                <div>{ text ? text.split(/\n|\s/).map(p => <div>{p}</div>) : '--' }</div>
                            </div>
                        }
                    },
                ]
                if(this.editable) {
                    res.push({
                        title: '操作',
                        key: 'action',
                        width: 100,
                        customRender: getCustomRender((text, record) => {
                            return <div class="row-btn">
                                <a class="txt-btn" onClick={() => this.editSch(record.di, record.si)}>编辑</a>
                                <a class="txt-btn danger" onClick={() => this.delSch(record.di, record.si)}>删除</a>
                            </div>
                        })
                    });
                }
                if(!create) {
                    res.splice(6, 0, {
                        title: '处理人',
                        dataIndex: 'user',
                        width: 90,
                        customRender: text => text && text.length > 0 ? text.map(u => u.name).join("、") : "--"
                    })
                }
                return res;
            }
        },
        watch: {
            activity() {
                this.getSchList();
            }
        },
        created() {
            this.getSchList();
        },
        methods: {
            confirmModal() {
                this.$refs.modalForm.$refs.schForm.handleConfirm().then(form => {
                    // 统一leader数据结构为数组形式 与后台接口返回的一致
                    if(!isArray(form.leader)) {
                        form.leader = [form.leader];
                    }
                    form.showTime = `${form.startTime}${form.endTime ?  ' - ' + form.endTime : ''}`
                    if(this.create) {
                        const day = this.list[this.di];
                        if(this.si === null) {
                            day.list.push({...form});
                        } else {
                            day.list.splice(this.si, 1, {...form});
                        }
                        this.dispatchChange();
                    } else {
                        this.updateSchedule(form);
                    }
                    this.visible = false;
                });
            },
            updateSchedule(form) {
                const day = this.list[this.di];
                const data = {
                    start_time: `${day.date} ${form.startTime}`,
                    end_time: form.endTime ? `${day.date} ${form.endTime}` : null,
                    user_id: form.leader[0].id + "",
                    activity_arrange: form.activity_arrange,
                    location: form.location,
                }
                let url = "/activity/activity-group", method = "POST";
                let info;
                // 新增
                if (this.si === null) {
                    info = this.getSchTaskUpdateInfo(form.task);
                    data.activity_id = this.activity.id;
                } else {
                    const sch = day.list[this.si];
                    url += `/${sch.id}`;
                    method = "PATCH";
                    info = this.getSchTaskUpdateInfo(form.task, sch.task);
                }
                if(info) {
                    data.task = JSON.stringify(info);
                }
                this.$axios({
                    url,
                    method,
                    data
                }).then(() => {
                    this.getSchList();
                });
            },
            getSchTaskUpdateInfo(newList, oldList) {
                const info = {};
                newList = newList || [];
                if(oldList && oldList.length > 0) {
                    const children = clone(oldList);
                    const add = [], update = [];
                    newList.forEach(task => {
                        if(task.id) {
                            const index = children.findIndex(c => c.id == task.id);
                            if(index >= 0) {
                                const child = children[index];
                                // 改变了任务名称和固定任务
                                if(child.name != task.name || Boolean(child.temp_id) != Boolean(task.temp_id)) {
                                    update.push({
                                        id: task.id,
                                        name: task.name,
                                        ...this.getTaskTempInfo(task)
                                    });
                                }
                                children.splice(index, 1);
                            } else {
                                // 原任务中找不到视为新增
                                add.push({
                                    name: task.name,
                                    ...this.getTaskTempInfo(task)
                                });
                            }
                        } else {
                            add.push({
                                name: task.name,
                                ...this.getTaskTempInfo(task)
                            });
                        }
                    });
                    const del = children.map(c => c.id);
                    add.length > 0 && (info.add = add);
                    update.length > 0 && (info.update = update);
                    del.length > 0 && (info.delete = del);
                } else if(newList.length > 0){
                    info.add = this.getFormatTaskList(newList);
                }
                return Object.keys(info).length > 0 ? info : null;
            },
            getTaskTempInfo(task) {
                const res = {};
                if(task.temp_id > 0) {
                    res.temp_id = task.temp_id;
                    res.module_ids = task.module_ids;
                    res.guide_book = task.guide_book;
                } else if(!this.create) {
                    res.temp_id = null;
                    res.module_ids = null;
                    res.guide_book = null;
                }
                return res;
            },
            getFormatTaskList(list) {
                return list.map(item => {
                    const t = { name: item.name, ...this.getTaskTempInfo(item) };
                    return t;
                });
            },
            dispatchChange() {
                const list = this.list;
                const res = [];
                list.forEach(day => {
                    day.list.forEach(sch => {
                        const g = omit(sch, ['startTime', 'endTime', 'task'])
                        g.start_time = `${day.date} ${sch.startTime}`;
                        g.end_time = sch.endTime ? `${day.date} ${sch.endTime}` : null;
                        g.user_id = sch.leader[0].id + "";
                        g.task = this.getFormatTaskList(sch.task);
                        res.push(g);
                    });
                });
                this.$emit("change", res);
            },
            getSchShowList(list, di) {
                const res = [];
                list.forEach((sch, si) => {
                    sch.task.forEach((item, i) => {
                        const t = {...item, di, si};
                        t.statusText = getTaskStatusText(item.status);
                        t.rowSpan = i == 0 ? sch.task.length : 0;
                        t.schedule = sch;
                        t.key = `${si}_${i}`;
                        res.push(t);
                   });
                });
                return res;
            },
            editSch(di, si) {
                this.di = di;
                this.si = si;
                const schedule = clone(this.list[di].list[si]);
                schedule.start_time && (schedule.startTime = getDate(schedule.start_time).pattern("HH:mm"));
                schedule.end_time && (schedule.endTime = getDate(schedule.end_time).pattern("HH:mm"));
                if(schedule.task && schedule.task.length > 0) {
                    schedule.task.forEach((t, i) => {
                        t.key = i;
                        t.temp_id = t.temp_id || 0;
                    });
                }
                this.schedule = schedule;
                this.visible = true;
            },
            delSch(di, si) {
                this.$confirm({
                    title: "提示",
                    content: "确定删除此日程吗？",
                    onOk: () => {
                        if(this.create) {
                            this.list[di].list.splice(si, 1);
                        } else {
                            const item = this.list[di].list[si];
                            this.$axios({
                                url: `/activity/activity-group/${item.id}`,
                                method: "DELETE"
                            }).then(() => this.list[di].list.splice(si, 1))
                        }
                    },
                });
            },
            addSch(i) {
                this.date = this.list[i].date;
                this.di = i;
                this.si = null;
                this.schedule = {};
                this.visible = true;
            },
            dealList(data) {
                const list = this.generateSchList();
                if(data && data.length > 0) {
                    data.forEach(item => {
                        const start = getDate(item.start_time);
                        const date = start.pattern("yyyy-MM-dd");
                        let time = start.pattern("HH:mm");
                        if (item.end_time) {
                            time += getDate(item.end_time).pattern("HH:mm");
                        }
                        item.time = time;
                        const day = list.find(d => d.date == date);
                        if(day) {
                            day.list.push(item);
                        } else {
                            list.push({
                                date,
                                list: [item]
                            })
                        }
                    });
                }
                // 计算当日日程进度
                if(!this.create) {
                    list.forEach(day => {
                        if(day.list && day.list.length > 0) {
                            let all = 0, done = 0;
                            day.list.forEach(sch => {
                                if(sch.progress) {
                                    all += sch.progress.all * 1;
                                    done += sch.progress.done * 1;
                                }
                            });
                            day.per = getProgressPercent({all, done});
                        }
                    })
                }
                this.list = list;
            },
            getSchList() {
                const create = this.create;
                const value = this.value;
                if(create) {
                    if(value) {
                        this.list = getActivityDayList(this.activity, value, create);
                    } else {
                        this.list = generateDaySchList(this.activity);
                    }
                } else if(this.activity){
                    this.loading = true;
                    const url = `/activity/activity-group?sort=start_time&expand=leader,task&pageSize=1000&filter[activity_id]=${this.activity.id}`;
                    this.$axios(url).then(res => {
                        this.list = getActivityDayList(this.activity, res.data, create);
                    }).finally(() => this.loading = false);
                }
            },
        }
    }
</script>

<style lang="less">
.create-schedule {
  min-height: 0;
}
.sch-date-list {
  padding: 16px;
}
.sch-date-item {
  &:not(:first-of-type) {
    margin-top: 16px;
  }
}
.sch-date-progress {
  width: 200px;
  margin-left: 20px;
}
.sch-task-type {
  flex-shrink: 0;
  margin-right: 4px;
  width: 18px;
  height: 18px;
  border: 1px solid;
  border-radius: 2px;
  text-align: center;
  line-height: 16px;
  font-size: 12px;
  cursor: pointer;
}
.sch-static-task {
  border-color: @blue-4;
  color: @blue-4;
}
.sch-custom-task {
  border-color: @orange-4;
  color: @orange-4;
}
.task-status-0 {
  color: @orange-6;
}
.task-status-1 {
  color: @green-6;
}
.task-status-2 {
  color: @red-6;
}
.sch-task-status {
  flex-shrink: 0;
  margin-right: 4px;
  font-size: 18px;
  cursor: pointer;
}
</style>
